import {
  Dialog,
  DialogContent,
  Box,
  Stack,
  Paper,
  useMediaQuery,
  useTheme,
  Grid,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Divider,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { grey } from "@mui/material/colors";
import { useTranslation } from "react-i18next";
import CardsWrapper from "./CardWrapper";
import {
  getCommunicationInfo,
  getCorrespondenceAddressDetails,
  getGeneralBuyerDetails,
  getOrganizationInfo,
  getRelationDetails,
  getRentersInformation,
} from "./utils";
import {
  getPersonMiddleNames,
  getPersonTitleBehind,
  getPersonTitleFor,
} from "../apis/profileApis";
import RowDetails from "./RowDetails";
import { Close } from "@mui/icons-material";
import { Button } from "@mui/material";
import { getSearchAddress } from "../apis/agendaApis";
import { debounce } from "../_helpers";

const AddBuyerRenter = ({ open, onClose, buyers, onSave }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobileOrTab = useMediaQuery(theme.breakpoints.down("md"));
    const communicationPerson = getCommunicationInfo(t, buyers);
    const [buyerFormData, setBuyerFormData] = useState({});
    const [dropdownValues, setDropdownValues] = useState({});
    const [errors, setErrors] = useState({});
    const [addressOptions, setAddressOptions] = useState([]);
    const [addressInput, setAddressInput] = useState("");
    const [loaders, setLoaders] = useState({});
    const [addressAutoCompleteOpen, setAddressAutoCompleteOpen] = useState(false);
    console.log({buyers})
    const renters = getRentersInformation(t, buyers, dropdownValues);
    const getGeneralBuyerDetail = getGeneralBuyerDetails(
      t,
      buyers,
      dropdownValues,
    );

const selectedType =
  buyerFormData["general.type"] ?? (buyers?.type === 1 ? "ORGANIZATION" : "PRIVATE"); 
    const isPrivateClient = selectedType === "PRIVATE";
    const isOrganization = selectedType === "ORGANIZATION";
    console.log({isPrivateClient});
    
    const handleChange = (name, value) => {
      setBuyerFormData((prev) => ({
        ...prev,
        [name]: value,
      }));

      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: undefined }));
      }
    };

    const buildInitialFormData = () => {
      const data = {};

      data["general.type"] = buyers?.general?.type ?? "PRIVATE";

      data["p1.lastName"] = buyers?.p1?.lastName ?? "";
      data["p1.gender"] = buyers?.p1?.gender ?? "";

      data["correspondence.addressId"] =
        buyers?.correspondenceAddress?.addressId ?? "";
      data["correspondence.salutation"] =
        buyers?.correspondence?.salutation ?? "";

      return data;
    };

    useEffect(() => {
      if (open && buyers) {
        setBuyerFormData(buildInitialFormData());
        setErrors({});
      }
    }, [open, buyers]);

    const searchAddress = async (address, selectedAddressId) => {
      try {
        setLoaders({ isAddressLoading: true });
        if (address.length >= 3) {
          const res = await getSearchAddress(address).then((p) => p.data);
          setAddressOptions(res);
          const selectedAddress = res.find((p) => p.id === selectedAddressId);
          if (selectedAddress) setAddressInput(selectedAddress);
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoaders({ isAddressLoading: false });
      }
    };

    const searchAddressHandler = debounce((address) => {
      searchAddress(address);
    }, 500);

    const validate = () => {
      let err = {};

      if (!buyerFormData["general.type"]) {
        err["general.type"] = t("general.field.error");
      }

      if (isPrivateClient) {
        if (!buyerFormData["p1.lastName"]) {
          err["p1.lastName"] = t("general.field.error");
        }
        //TODO: After confirmation from Abhishek uncomment these validations
        // if (!buyerFormData["p1.gender"]) {
        //   err["p1.gender"] = t("general.field.error");
        // }
        // if (!buyerFormData["correspondence.salutation"]) {
        //   err["correspondence.salutation"] = t("general.field.error");
        // }
        if (!buyerFormData["correspondence.addressId"]) {
          err["correspondence.addressId"] = t("general.field.error");
        }
      }
      setErrors(err);
      return Object.keys(err).length === 0;
    };
    
    //TODO: dummy added clientTypes
    useEffect(() => {
      (async () => {
        const results = await Promise.all([
          getPersonTitleFor(),
          getPersonMiddleNames(),
          getPersonTitleBehind(),
        ]);

        const normalize = (arr) =>
          (arr || []).map((item) => ({
            label: item.label || item.name || item.description,
            value: item.value || item.id || item.code,
          }));

        setDropdownValues({
          titleFor: normalize(results[0].data),
          middleNames: normalize(results[1].data),
          titleBehind: normalize(results[2].data),
          genders: [
            { label: t("general.male"), value: 0 },
            { label: t("general.female"), value: 1 },
            { label: t("general.unknown"), value: 3 },
          ],
          clientTypes: [
            {
              label: t("buyersGuide.buyerActions.add.privateClient"),
              value: "PRIVATE",
            },
            { label: t("general.organisation"), value: "ORGANIZATION" },
          ],
          statuses: [
            { label: t("general.buyer"), value: "BUYER" },
            { label: "Renter", value: "RENTER" },
          ],
        });
      })();
    }, []);

    const handleSave = () => {
      if (!validate()) return;
      console.log("Saved data:", buyerFormData);
      //   const payload = buildPayload();
      //   onSave(payload);
      onClose();
    };

    if (!buyers) {
      return [];
    }

    return (
      <Dialog
        open={open}
        onClose={(event, reason) =>
        reason === 'backdropClick' ? event.stopPropagation() : onClose()
        }
        fullScreen={isMobileOrTab}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            maxWidth: "none",
            width: 1200,
            height: { md: 650 },
          },
        }}
      >
        <AppBar position="relative" sx={{ boxShadow: "none" }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onClose}>
              <Close />
            </IconButton>

            <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
              {t("buyersGuide.buyerActions.add")}
            </Typography>

            <Button color="inherit" onClick={onClose}>
              {t("general.cancel")}
            </Button>

            <Button
              color="inherit"
              variant="outlined"
              sx={{ ml: 1 }}
              onClick={handleSave}
            >
              {t("general.save")}
            </Button>
          </Toolbar>
        </AppBar>

        <DialogContent>
          <Box
            sx={{
              flexGrow: 1,
              bgcolor: grey[100],
              p: 2,
              overflow: "auto",
              height: "100%",
            }}
          >
            <Stack
              sx={{
                flexGrow: 1,
                my: 2,
              }}
              spacing={2}
            >
              <Paper
                sx={{ width: "100%", bgcolor: "common.white" }}
                elevation={0}
              >
                <CardsWrapper>
                  <Grid container sx={{ py: 1 }}>
                    <Grid
                      sx={{
                        borderRight: {
                          xs: "none",
                          md: `1px dashed ${grey[200]}`,
                        },
                      }}
                      size={{ xs: 12, sm: 6, md: 4 }}
                    >
                      <Grid container spacing={0.5} sx={{ px: 2 }}>
                        <Grid size={{ xs: 12 }}>
                          <Typography variant="subtitle2">
                            {getGeneralBuyerDetail[0]?.title}
                          </Typography>
                        </Grid>

                        {getGeneralBuyerDetail[0]?.details?.map((detail, idx) => (
                          <Grid size={{ xs: 12 }} key={idx}>
                            <RowDetails
                              {...detail}
                              error={errors[detail.name]}
                              onChange={handleChange}
                              value={buyerFormData[detail.name] ?? detail.value ?? ""}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                    <Grid
                      sx={{
                        borderRight: {
                          xs: "none",
                          md: `1px dashed ${grey[200]}`,
                        },
                      }}
                      size={{ xs: 12, sm: 6, md: 4 }}
                    >
                      <Grid container spacing={0.5} sx={{ px: 2 }}>
                        <Grid size={{ xs: 12 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              mt: { xs: 3, md: 0 },
                              mb: { xs: 1.5, md: 0 },
                            }}
                          >
                            {getGeneralBuyerDetail[1]?.title}
                          </Typography>
                        </Grid>
                        {getGeneralBuyerDetail[1]?.details?.map((detail, idx) => (
                          <Grid size={{ xs: 12 }} key={idx}>
                            <RowDetails
                              {...detail}
                              error={errors[detail.name]}
                              onChange={handleChange}
                              value={buyerFormData[detail.name] ?? detail.value ?? ""}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                </CardsWrapper>
              </Paper>

              {isPrivateClient && buyers?.type === 0 && (
                <Paper
                  sx={{ width: "100%", bgcolor: "common.white" }}
                  elevation={0}
                >
                  <CardsWrapper>
                    <Grid container sx={{ py: 1 }}>
                      <Grid
                        sx={{
                          borderRight: {
                            xs: "none",
                            md: `1px dashed ${grey[200]}`,
                          },
                        }}
                        size={{ xs: 12, sm: 6, md: 4 }}
                      >
                        <Grid container spacing={0.5} sx={{ px: 2 }}>
                          <Grid size={{ xs: 12 }}>
                            <Typography variant="subtitle2">
                              {renters[0]?.title}
                            </Typography>
                          </Grid>
                          {renters[0]?.details?.map((detail, idx) => (
                            <Grid size={{ xs: 12 }} key={idx}>
                              <RowDetails
                                {...detail}
                                error={errors[detail.name]}
                                onChange={handleChange}
                                value={
                                  buyerFormData[detail.name] ?? detail.value ?? ""
                                }
                                disabled={renters[0].isDisabled}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>

                      {/* {buyers.p2 && ( */}
                        <Grid
                          sx={{
                            borderRight: {
                              xs: "none",
                              md: `1px dashed ${grey[200]}`,
                            },
                          }}
                          size={{ xs: 12, sm: 6, md: 4 }}
                        >
                          <Grid container spacing={0.5} sx={{ px: 2 }}>
                            <Grid size={{ xs: 12 }}>
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  mt: { xs: 3, md: 0 },
                                  mb: { xs: 1.5, md: 0 },
                                }}
                              >
                                {communicationPerson[0]?.title}
                              </Typography>
                            </Grid>
                            {communicationPerson[0]?.details?.map((detail, idx) => (
                              <Grid size={{ xs: 12 }} key={idx}>
                                <RowDetails
                                  {...detail}
                                  error={errors[detail.name]}
                                  onChange={handleChange}
                                  value={
                                    buyerFormData[detail.name] ?? detail.value ?? ""
                                  }
                                  disabled={communicationPerson[0]?.isDisabled}
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      {/* )} */}

                      <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                        <Grid container spacing={0.5} sx={{ px: 2 }}>
                          <Grid size={{ xs: 12 }}>
                            <Typography variant="subtitle2">
                              {t(
                                "buyersGuide.buyerActions.correspondenceAddress",
                              )}
                            </Typography>
                          </Grid>

                          {getCorrespondenceAddressDetails(
                            t,
                            buyers,
                            dropdownValues,
                          ).map((detail, idx) => (
                            <Grid size={{ xs: 12 }} key={idx}>
                              {detail.name === "correspondence.addressId" ? (
                                <Grid container spacing={1}>
                                  <Grid size={{ xs: 12, sm: 5 }}>
                                    <Typography variant="caption">
                                      {detail.title}
                                    </Typography>
                                  </Grid>
                                  <Grid size={{ xs: 12, sm: 7 }}>
                                    <Autocomplete
                                      id="correspondence-address"
                                      className="custom-autocomplete"
                                      options={addressOptions}
                                      loading={loaders.isAddressLoading}
                                      open={addressAutoCompleteOpen}
                                      inputValue={addressInput} 
                                      value={
                                        addressOptions.find(
                                          (opt) =>
                                            opt.id === buyerFormData[detail.name],
                                        ) || null 
                                      }
                                      onOpen={() =>
                                        setAddressAutoCompleteOpen(true)
                                      }
                                      onClose={() =>
                                        setAddressAutoCompleteOpen(false)
                                      }
                                      getOptionLabel={(option) =>
                                        option?.name || ""
                                      }
                                      isOptionEqualToValue={(opt, val) =>
                                        opt.id === val.id
                                      }
                                      onInputChange={(
                                        _,
                                        newInputValue,
                                        reason,
                                      ) => {
                                        if (reason === "input") {
                                          setAddressInput(newInputValue);
                                          searchAddressHandler(newInputValue);
                                        }
                                      }}
                                      onChange={(_, newValue) => {
                                        handleChange(
                                          detail.name,
                                          newValue ? newValue.id : "",
                                        );
                                        setAddressInput(newValue?.name || ""); 
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          size="small"
                                          error={!!errors[detail.name]}
                                          helperText={errors[detail.name]}
                                          InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                              <>
                                                {loaders.isAddressLoading && (
                                                  <CircularProgress size={20} />
                                                )}
                                                {params.InputProps.endAdornment}
                                              </>
                                            ),
                                          }}
                                        />
                                      )}
                                    />
                                  </Grid>
                                </Grid>
                              ) : (
                                <RowDetails
                                  {...detail}
                                  value={
                                    buyerFormData[detail.name] ?? detail.value ?? ""
                                  }
                                  error={errors[detail.name]}
                                  onChange={handleChange}
                                />
                              )}
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardsWrapper>
                </Paper>
              )}
              {isPrivateClient && buyers?.type === 0 &&  (
                <Paper
                  sx={{ width: "100%", bgcolor: "common.white" }}
                  elevation={0}
                >
                  <CardsWrapper>
                    <Grid container sx={{ py: 1 }}>
                      <Grid
                        sx={{
                          borderRight: {
                            xs: "none",
                            md: `1px dashed ${grey[200]}`,
                          },
                        }}
                        size={{ xs: 12, sm: 6, md: 4 }}
                      >
                        <Grid container spacing={0.5} sx={{ px: 2 }}>
                          <Grid size={{ xs: 12 }}>
                            <Typography variant="subtitle2">
                              {renters[1]?.title}
                            </Typography>
                          </Grid>
                          {renters[1]?.details?.map((detail, idx) => (
                            <Grid size={{ xs: 12 }} key={idx}>
                              <RowDetails
                                {...detail}
                                value={
                                  buyerFormData[detail.name] ?? detail.value ?? ""
                                }
                                error={errors[detail.name]}
                                onChange={handleChange}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>

                      <Grid
                        sx={{
                          borderRight: {
                            xs: "none",
                            md: `1px dashed ${grey[200]}`,
                          },
                        }}
                        size={{ xs: 12, sm: 6, md: 4 }}
                      >
                        <Grid container spacing={0.5} sx={{ px: 2 }}>
                          <Grid size={{ xs: 12 }}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                mt: { xs: 3, md: 0 },
                                mb: { xs: 1.5, md: 0 },
                              }}
                            >
                              {communicationPerson[1]?.title}
                            </Typography>
                          </Grid>
                          {communicationPerson[1]?.details?.map((detail, idx) => (
                            <Grid size={{ xs: 12 }} key={idx}>
                              <RowDetails
                                {...detail}
                                value={
                                  buyerFormData[detail.name] ?? detail.value ?? ""
                                }
                                error={errors[detail.name]}
                                onChange={handleChange}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardsWrapper>
                </Paper>
              )}
              {isOrganization && (
                <Paper
                  sx={{ width: "100%", bgcolor: "common.white" }}
                  elevation={0}
                >
                  <CardsWrapper>
                    <Grid container sx={{ py: 1 }}>
                      <Grid
                        sx={{
                          borderRight: {
                            xs: "none",
                            md: `1px dashed ${grey[200]}`,
                          },
                        }}
                        size={{ xs: 12, sm: 6, md: 4 }}
                      >
                        <Grid container spacing={0.5} sx={{ px: 2 }}>
                          <Grid size={{ xs: 12 }}>
                            <Typography variant="subtitle2">
                              {t("general.organisation")}
                            </Typography>
                          </Grid>

                          {getOrganizationInfo(t, buyers, dropdownValues).map(
                            (detail, idx) => (
                              <Grid size={{ xs: 12 }} key={idx}>
                                <RowDetails
                                  key={idx}
                                  {...detail}
                                  error={errors[detail.name]}
                                  onChange={handleChange}
                                  value={
                                    buyerFormData[detail.name] ?? detail.value ?? ""
                                  }
                                />
                              </Grid>
                            ),
                          )}
                        </Grid>
                      </Grid>

                      <Grid
                        sx={{
                          borderRight: {
                            xs: "none",
                            md: `1px dashed ${grey[200]}`,
                          },
                        }}
                        size={{ xs: 12, sm: 6, md: 4 }}
                      >
                        <Grid container spacing={0.5} sx={{ px: 2 }}>
                          <Grid size={{ xs: 12 }}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                mt: { xs: 3, md: 0 },
                                mb: { xs: 1.5, md: 0 },
                              }}
                            >
                              {t("workOrders.relation")}
                            </Typography>
                          </Grid>

                          {getRelationDetails(t, buyers, dropdownValues).map(
                            (detail, idx) => (
                              <Grid size={{ xs: 12 }} key={idx}>
                                <RowDetails
                                  key={idx}
                                  {...detail}
                                  error={errors[detail.name]}
                                  onChange={handleChange}
                                  value={
                                    buyerFormData[detail.name] ?? detail.value ?? ""
                                  }
                                />
                              </Grid>
                            ),
                          )}
                        </Grid>
                      </Grid>

                      <Grid
                        size={{ xs: 12, sm: 12, md: 4 }}
                        sx={{ minHeight: 240 }}
                      />
                    </Grid>
                  </CardsWrapper>
                </Paper>
              )}
            </Stack>
          </Box>
        </DialogContent>
      </Dialog>
    );
  };

export default AddBuyerRenter;
